import React from 'react';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  description?: string;
  gradientFrom?: string;
  gradientTo?: string;
}

export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  description,
  gradientFrom = 'from-blue-600',
  gradientTo = 'to-indigo-600'
}) => {
  return (
    <>
      {/* Подключение локального шрифта Avenir Next W1G Medium */}
      <style dangerouslySetInnerHTML={{
        __html: `
          @font-face {
            font-family: 'Avenir Next W1G';
            src: url('/TikTokSans.ttf') format('truetype');
            font-weight: 500;
            font-style: normal;
            font-display: swap;
          }
        `
      }} />
      
      <header className="mb-8" style={{ fontFamily: 'Avenir Next W1G, system-ui, sans-serif' }}>
        <div className="text-center space-y-3">
          <h1 
            className={`text-4xl md:text-5xl lg:text-6xl font-medium bg-gradient-to-r ${gradientFrom} ${gradientTo} bg-clip-text text-transparent tracking-tight leading-tight`}
            style={{ 
              fontFamily: 'Avenir Next W1G, system-ui, sans-serif',
              fontWeight: '500'
            }}
          >
            {title}
          </h1>
          
          {subtitle && (
            <p 
              className="text-lg font-normal text-slate-600 dark:text-slate-400 max-w-2xl mx-auto leading-relaxed"
              style={{ 
                fontFamily: 'Avenir Next W1G, system-ui, sans-serif',
                fontWeight: '500'
              }}
            >
              {subtitle}
            </p>
          )}

          {description && (
            <p 
              className="text-base font-light text-slate-500 dark:text-slate-500 max-w-xl mx-auto leading-relaxed"
              style={{ 
                fontFamily: 'Avenir Next W1G, system-ui, sans-serif',
                fontWeight: '500'
              }}
            >
              {description}
            </p>
          )}
        </div>
      </header>
    </>
  );
}; 